module.exports = __webpack_public_path__ + "static/worksection-d1128bf5ca307e9ce7a15e10ff1b946e.svg";